module.exports = __webpack_public_path__ + "static/media/gsb-iconFood-&-Beverage.b36d3412.svg";